import { category, range } from './layer-builder';

export const overlayLayers = {
  header: 'Overlays',
  id: 'boundary-layers',
  layers: [
    {
      label: 'Road Labels',
      key: 'road_label_layer',
      default: true,
      url:
        'https://stamen-tiles-a.a.ssl.fastly.net/toner-labels/{z}/{x}/{y}@2x.png',
      style: {
        type: 'raster',
      },
    },
    {
      label: 'Roads',
      key: 'road_layer',
      default: true,
      url:
        'https://stamen-tiles.a.ssl.fastly.net/toner-lines/{z}/{x}/{y}@2x.png',
      style: {
        type: 'raster',
      },
    },
    {
      label: 'Parcel Boundaries',
      key: 'parcel_id',
      forceDots: true,
      style: {
        type: 'line',
        paint: {
          'line-color': '#4b4c4d',
          'line-width': 1,
          'line-dasharray': [2, 2],
        },
      },
    },
    {
      label: 'City Boundary',
      key: 'namelsad10',
      default: true,
      source: 'gis_city',
      style: {
        type: 'line',
        paint: {
          'line-color': '#4b4c4d',
          'line-width': 2,
          'line-dasharray': [2, 2],
        },
      },
    },
  ],
};

export const codeEnforcement = {
  header: 'Code Enforcement Layers',
  id: 'code-enforcement-layers',
  layers: [
    range({
      label: 'Open Permit Count',
      key: 'open_permit_count',
      forceDots: true,
      colorScheme: 'positive-1',
      download: {
        keys: ['address', 'parcel_id', 'open_permit_count'],
      },
    }),
    category({
      label: 'Rental Permit or Certificate',
      key: 'rental_license',
      forceDots: true,
      colorScheme: 'positive-2',
      download: {
        keys: ['address', 'parcel_id', 'rental_license'],
      },
    }),
    range({
      label: 'Open Violations',
      key: 'open_violation_count',
      forceDots: true,
      colorScheme: 'negative-2',
      download: {
        keys: ['address', 'parcel_id', 'open_violation_count'],
      },
    }),
    range({
      label: 'Violations since last change of ownership at this property or in the past two years',
      key: 'violation_2y_count',
      forceDots: true,
      colorScheme: 'negative-2',
      download: {
        keys: ['address', 'parcel_id', 'violation_2y_count'],
      },
    }),
    range({
      label: 'Violations at other properties owned by owner in past 2 years or since ownership',
      key: 'violation_owner_2y',
      forceDots: true,
      colorScheme: 'negative-2',
      download: {
        keys: ['address', 'parcel_id', 'violation_owner_2y'],
      },
    }),
    // range({
    //   label: '911 Incident Heatmap',
    //   key: 'crime_incident',
    //   forceDots: true,
    //   colorScheme: 'negative-2',
    // }),
    {
      label: '911 Incident Heatmap',
      key: 'crime_incident',
      style: {
        type: 'heatmap',
        paint: {
          'heatmap-weight': {
            property: 'crime_incident',
            type: 'exponential',
            default: 0,
            stops: [
              [0, 0],
              [100, 1],
            ],
          },
          // Increase the heatmap color weight by zoom level
          // heatmap-intensity is a multiplier on top of heatmap-weight
          'heatmap-intensity': {
            stops: [
              [12, 5],
              [15, 11],
            ],
          },
          // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
          // Begin color ramp at 0-stop with a 0-transparancy color
          // to create a blur-like effect.
          'heatmap-color': [
            'interpolate',
            ['linear'],
            ['heatmap-density'],
            0.0,
            'rgba(0, 0, 0, 0)',
            0.1,
            '#4444FF',
            0.7,
            '#FF0000',
            1,
            '#FFFF00',
          ],
          // Adjust the heatmap radius by zoom level
          'heatmap-radius': [
            'interpolate',
            ['linear'],
            ['zoom'],
            3,
            12,
            16,
            20,
          ],
          // Transition from heatmap to circle layer by zoom level
          'heatmap-opacity': 0.6,
        },
      },
    },
  ],
};

export const codeEnforcementNoDownload = {
  header: 'Code Enforcement Layers',
  id: 'code-enforcement-layers',
  layers: [
    range({
      label: 'Open Permit Count',
      key: 'open_permit_count',
      forceDots: true,
      colorScheme: 'positive-1',
    }),
    category({
      label: 'Rental Permit or Certificate',
      key: 'rental_license',
      forceDots: true,
      colorScheme: 'positive-2',
    }),
    range({
      label: 'Open Violations',
      key: 'open_violation_count',
      forceDots: true,
      colorScheme: 'negative-2',
    }),
    range({
      label: 'Violations since last change of ownership at this property or in the past two years',
      key: 'violation_2y_count',
      forceDots: true,
      colorScheme: 'negative-2',
    }),
    range({
      label: 'Violations at other properties owned by owner in past 2 years or since ownership',
      key: 'violation_owner_2y',
      forceDots: true,
      colorScheme: 'negative-2',
    }),
    // range({
    //   label: '911 Incident Heatmap',
    //   key: 'crime_incident',
    //   forceDots: true,
    //   colorScheme: 'negative-2',
    // }),
    {
      label: '911 Incident Heatmap',
      key: 'crime_incident',
      style: {
        type: 'heatmap',
        paint: {
          'heatmap-weight': {
            property: 'crime_incident',
            type: 'exponential',
            default: 0,
            stops: [
              [0, 0],
              [100, 1],
            ],
          },
          // Increase the heatmap color weight by zoom level
          // heatmap-intensity is a multiplier on top of heatmap-weight
          'heatmap-intensity': {
            stops: [
              [12, 5],
              [15, 11],
            ],
          },
          // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
          // Begin color ramp at 0-stop with a 0-transparancy color
          // to create a blur-like effect.
          'heatmap-color': [
            'interpolate',
            ['linear'],
            ['heatmap-density'],
            0.0,
            'rgba(0, 0, 0, 0)',
            0.1,
            '#4444FF',
            0.7,
            '#FF0000',
            1,
            '#FFFF00',
          ],
          // Adjust the heatmap radius by zoom level
          'heatmap-radius': [
            'interpolate',
            ['linear'],
            ['zoom'],
            3,
            12,
            16,
            20,
          ],
          // Transition from heatmap to circle layer by zoom level
          'heatmap-opacity': 0.6,
        },
      },
    },
  ],
};
